/**
 * GamePlayer - Page wrapper for games
 * Supports multiple games via URL parameter
 */
import { useNavigate, useParams } from 'react-router-dom';
import { PipGame, PipJourney } from '../components/game';
import BubblePop from '../components/game/bubble-pop';
import DoorKnock from '../components/game/door-knock';
import IsaacNoYoutube from '../components/game/isaac-no-youtube';

const GAMES = {
  'pips-kitchen': PipGame,
  'pips-journey': PipJourney,
  // The engine-native game. Its id must match games(id) in the database and
  // content/index.js GAME.id, because every attempt it records is keyed on it.
  'bubble-pop': BubblePop,
  // The second engine-native game. Its id matches games(id) and the coverage
  // declaration in its own content, because every attempt is keyed on it.
  'door-knock': DoorKnock,
  // The third. Phase 1 in full: a screen glowing in the corner, and a room that
  // fills with people as the child names them. Its id matches games(id) and the
  // coverage declaration in its own content.
  'isaac-no-youtube': IsaacNoYoutube,
};

export default function GamePlayer() {
  const navigate = useNavigate();
  const { gameId } = useParams();
  
  const handleExit = () => {
    navigate('/games');
  };

  // Get the game component based on URL
  const GameComponent = GAMES[gameId] || PipGame;

  return <GameComponent onExit={handleExit} />;
}
